/* tslint:disable */
/* eslint-disable */
/**
 * merged spec
 * merged spec
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ActivityState;
(function (ActivityState) {
    ActivityState["Unscheduled"] = "unscheduled";
    ActivityState["Scheduled"] = "scheduled";
    ActivityState["Canceled"] = "canceled";
})(ActivityState || (ActivityState = {}));
